import React from 'react';
export const Footer = () => {
  return <footer className="bg-charcoal text-white py-6 md:py-12 px-4 border-t border-white/10" data-id="element-66">
      <div className="max-w-6xl mx-auto text-center" data-id="element-67">
        <h2 className="text-2xl md:text-3xl font-extrabold mb-3 md:mb-4" data-id="element-68">
          GAP 360™
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto mb-4 md:mb-8 text-sm md:text-base" data-id="element-69">
          El sistema de clases N°1 de GAP para instructoras de GAP en Argentina.
          Porque enseñar GAP no debería costarte todas las noches de la semana.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-6 text-gray-300 text-sm mb-6 md:mb-12" data-id="element-70">
          <a href="mailto:contacto@rincondocente360.com" className="hover:text-coral transition-colors" data-id="element-71">
            📧 contacto@rincondocente360.com
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-72">|</span>
          <a href="#" className="hover:text-coral transition-colors" data-id="element-73">
            📲 @rincondocente360
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-74">|</span>
          <a href="https://gap.rincondocente360.com" className="hover:text-coral transition-colors" data-id="element-75">
            🌐 gap.rincondocente360.com
          </a>
        </div>

        <div className="text-xs md:text-sm text-gray-500 border-t border-white/10 pt-6 md:pt-8" data-id="element-76">
          <p data-id="element-77">© RinconDocente360™ 2026 — Todos los derechos reservados.</p>
          <p className="mt-1 md:mt-2" data-id="element-78">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
};